import {
  ExistingPolicies,
  TriggerPolicyConnectionStatusEnum,
  TriggerPolicyLevelMaskEnum,
  TriggerPolicyTypeEnum,
} from "../components/Policies/type.util";

export const policyAndReverse = (event: any, policy: ExistingPolicies, deviceGroups: any[]) => {
  if (event.label === "CONDITION ON") {
    if (policy.type === TriggerPolicyTypeEnum.ANALOG_BAND) {
      event.policy = {
        ...policy,
        inside: Boolean(policy.inside),
        minOrEqual: Boolean(policy.minOrEqual),
        min: Number(policy.min),
        maxOrEqual: Boolean(policy.maxOrEqual),
        max: Number(policy.max),
        time: Number(policy.time),
      };
      event.deviceGroups = deviceGroups.length > 0 ? deviceGroups.map(dg => dg.name) : ['*'];
    }
    if (policy.type === TriggerPolicyTypeEnum.CONNECTION) {
      event.policy = { ...policy, time: Number(policy.time) };
      event.deviceGroups = deviceGroups.length > 0 ? deviceGroups.map(dg => dg.name) : ['*'];
    }
    if (policy.type === TriggerPolicyTypeEnum.ON_LEVEL) {
      event.policy = {
        ...policy,
        minOrEqual: Boolean(policy.minOrEqual),
        min: !Number.isNaN(Number(policy.min)) ? Number(policy.min) : NaN,
        maxOrEqual: Boolean(policy.maxOrEqual),
        max: !Number.isNaN(Number(policy.max)) ? Number(policy.max) : NaN,
        skipFirstChanges: Number(policy.skipFirstChanges),
      };
      event.deviceGroups = deviceGroups.length > 0 ? deviceGroups.map(dg => dg.name) : ['*'];
    }
    if (policy.type === TriggerPolicyTypeEnum.ON_CHANGED) {
      event.policy = {
        ...policy,
        isPercentage: Boolean(policy.isPercentage),
        deadband: Number(policy.deadband),
        skipFirstNChanges: Number(policy.skipFirstNChanges),
      };
      event.deviceGroups = deviceGroups.length > 0 ? deviceGroups.map(dg => dg.name) : ['*'];
    }
  }
  if (event.label === "CONDITION OFF") {
    if (policy.type === TriggerPolicyTypeEnum.ANALOG_BAND) {
      event.policy = {
        ...policy,
        inside: !policy.inside,
        minOrEqual: Boolean(policy.minOrEqual),
        min: Number(policy.min),
        maxOrEqual: Boolean(policy.maxOrEqual),
        max: Number(policy.max),
        time: 0,
      };
      event.deviceGroups = deviceGroups.length > 0 ? deviceGroups.map(dg => dg.name) : ['*'];
    }
    if (policy.type === TriggerPolicyTypeEnum.CONNECTION) {
      event.policy = {
        ...policy,
        time: 0,
        status: policy.status === TriggerPolicyConnectionStatusEnum.ON
          ? TriggerPolicyConnectionStatusEnum.OFF
          : TriggerPolicyConnectionStatusEnum.ON,
      };
      event.deviceGroups = deviceGroups.length > 0 ? deviceGroups.map(dg => dg.name) : ['*'];
    }
    if (policy.type === TriggerPolicyTypeEnum.ON_LEVEL) {
      event.policy = {
        ...policy,
        minOrEqual: Boolean(policy.minOrEqual),
        min: !Number.isNaN(Number(policy.min)) ? Number(policy.min) : NaN,
        maxOrEqual: Boolean(policy.maxOrEqual),
        max: !Number.isNaN(Number(policy.max)) ? Number(policy.max) : NaN,
        skipFirstChanges: 0,
        mode: policy.mode === TriggerPolicyLevelMaskEnum.ON_ENTER
          ? TriggerPolicyLevelMaskEnum.ON_EXIT
          : TriggerPolicyLevelMaskEnum.ON_ENTER,
      };
      event.deviceGroups = deviceGroups.length > 0 ? deviceGroups.map(dg => dg.name) : ['*'];
    }
    if (policy.type === TriggerPolicyTypeEnum.ON_CHANGED) {
      delete event.policy;
      event.type = "TEMPORIZED";
    }
  }
  return event;
};
